module.exports = __webpack_public_path__ + "static/mockup_phone@2x-585502dc59446ab9821293dc9d3860b1.png";